
import { FaCoffee, FaGlassMartiniAlt, FaGlassWhiskey } from 'react-icons/fa';
import { FaStroopwafel } from 'react-icons/fa6';
import { LuBox, LuCupSoda, LuDonut } from 'react-icons/lu';
import { RiDrinks2Line } from 'react-icons/ri';
// coffee corner
import IcedFrape from '../images/frappuccino.webp';
import IcedAmrecano from '../images/iced amrecano.webp';
import IcedCoffee from '../images/iced coffee.webp';
import IcedCortado from '../images/iced cortado.webp';
import IcedLotus from '../images/iced lotus.jpg';
import IcedlatteMatcha from '../images/iced matcha lattee.jpeg';
import IcedMocha from '../images/iced mocha.jpeg';
import IcedNuttella from '../images/iced nuttella.png';
import IcedLatte from '../images/iced-latte.jpg';
import IcedSpanishLatte from '../images/iced-spanish-latte.jpg';
import MatchaFrappe from '../images/matcha frappe.jpeg';

// milk shake corner
import MilkShakeChocolateDobai from '../images/milk shake chocolate dobai.png';
import MilkShakeHohos from '../images/milk shake hohos.jpg';
import MilkShakeCoffee from '../images/milk shake iced coffee.jpeg';
import MilkShakeLemonMint from '../images/milk shake lemon mint.webp';
import MilkShakeMatcha from '../images/milk shake matcha.webp';
import MilkShakePeach from '../images/milk shake peach.webp';
import MilkShakeRafayello from '../images/milk shake rafayello.webp';
import MilkShakeTaro from '../images/milk shake taro.webp';
import MilkShakeTwinkies from '../images/milk shake twinkies.jpg';
import MilkShakeWatermelon from '../images/milk shake watermelon.jpg';
import MilkShakeBlueBerry from '../images/MilkShake blue-berry.webp';
import MilkShakeKinder from '../images/MilkShake kinder.webp';
import MilkShakeLotus from '../images/MilkShake lotus.webp';
import MilkShakeMango from '../images/MilkShake mango.webp';
import MilkShakeOreo from '../images/MilkShake oreo.jpeg';
import MilkShakePistacio from '../images/MilkShake Pistachio.webp';
import MilkShakeStrawberry from '../images/MilkShake strawberry.webp';
import MilkShakeVanilla from '../images/MilkShake vanilla.webp';

// Smothie corner
import { FaWhiskeyGlass } from 'react-icons/fa6';
import { GiAvocado, GiExpander, GiFireSpellCast, GiTacos } from 'react-icons/gi';
import DragonFruitSmothie from '../images/dragon fruit juice.webp';
import GuavaKiwiMint from '../images/guava kiwi mint.webp';
import AppleSmothie from '../images/Smothie apple.webp';
import BlueBerrySmothie from '../images/Smothie blueberry.webp';
import DatesSmothie from '../images/smothie dates.jpeg';
import GrapesSmothie from '../images/Smothie grapes.webp';
import GuavaSmothie from '../images/Smothie guava.webp';
import IcecreamMango from '../images/smothie ice cream mango.avif';
import IcecreamStrawberry from '../images/smothie ice cream strawberry.webp';
import KiwiLemonMint from '../images/smothie kiwi lemon mint.webp';
import KiwiMango from '../images/smothie kiwi mango.png';
import KiwiPineapple from '../images/smothie kiwi pineapple.webp';
import KiwiSmothie from '../images/Smothie kiwi.webp';
import LemonSmothie from '../images/Smothie lemonmint.webp';
import MangoPassionSmothie from '../images/smothie mango passion.webp';
import MangoSmothie from '../images/Smothie mango.webp';
import MixBerry from '../images/Smothie mixBerry.webp';
import OrangeSmothie from '../images/Smothie orange.webp';
import PassionSmothie from '../images/Smothie passion.webp';
import PeachSmothie from '../images/Smothie peach.webp';
import PineappleSmothie from '../images/Smothie pineapple.webp';
import RassperrrySmothie from '../images/smothie rassberry.webp';
import StrawberrySmothie from '../images/Smothie strawberry.jpeg';
import WaterMElonMint from '../images/smothie watermelon mint.webp';
import WatermelonSmothie from '../images/Smothie watermelon.webp';
import YousfiCoconut from '../images/smothie يوسفي جوزهند.jpg';

//fresh juice corner
import BananaMilk from '../images/banana mikl juice.webp';
import CantalopMilk from '../images/cantalop milk juice.jpg';
import DatesMilk from '../images/dates milk juice.webp';
import DragonFruit from '../images/dragon fruit juice.webp';
import Grapes from '../images/grapes.webp';
import Guava from '../images/guava juice.webp';
import GuavaMilk from '../images/guava milk juice.webp';
import Kiwi from '../images/kiwi juice.jpeg';
import Lemonmint from '../images/lemon mint juice.webp';
import lemonada from '../images/lemonada juice.webp';
import Mango from '../images/mango juice.webp';
import Coconut from '../images/natural coconut jiuce.jpg';
import Orange from '../images/orange juice.webp';
import Peach from '../images/peach juice.webp';
import Pineapple from '../images/pineapple juice.avif';
import Strawberry from '../images/strawberry juice.jpeg';
import Watermelon from '../images/water melon juice.webp';

//boba corner
import BobaIcedCoffe from '../images/boba iced coffee.jpeg';
import BobaMilkShakeStrawberry from '../images/boba mil shake strawberry.jpeg';
import BobaMilkShakeBlueBerry from '../images/boba milk shake blueberry.avif';
import BobaMilkShakeCaramel from '../images/boba milk shake caramel.jpg';
import BobaMilkShakeChocolate from '../images/boba milk shake chococlate.webp';
import BobaMilkShakelotus from '../images/boba milk shake lotus.jpg';
import BobaMilkShakeMatcha from '../images/boba milk shake matcha.jpg';
import BobaMilkShakeTaro from '../images/boba milk shake taro.webp';
import BobaMikShakeVanellia from '../images/boba milk shake vanellia.webp';
import BobaMocha from '../images/boba mocha.webp';
import BobaKiwi from '../images/boba smothie kiwi.webp';
import BobaMango from '../images/boba smothie mango.webp';
import BobaPeach from '../images/boba smothie peach.webp';
import BobaStrawberry from '../images/boba smothie strawberry.jpg';
import BobaWatermelon from '../images/boba smothie watermelon.webp';
import BobaSodaPassion from '../images/boba soda passion fruit.jpg';
import BobaSpanishLatte from '../images/boba Spanish latte.webp';
import BobaFrappe from '../images/frappuccino.webp';

 const menuCategories =[
    //coffe corner
    {
      name: 'قهوه بارده',
      icon: <FaCoffee />,
      items: [
  {
    id: '1',
    name: 'ايس لاتيه',
    price: '60 LE',
    image: IcedLatte
  },
  {
    id: 2,
    name: 'ايس سبانيش لاتيه',
    price: '65 LE',
    image: IcedSpanishLatte
  }, {
    id: 3,
    name: 'ايس امريكانو',
    price: '55 LE',
    image: IcedAmrecano
  }, {
    id: 4,
    name: 'ايس كوفي لوتس',
    price: '55 LE',
    image: IcedLotus
  },
  {
    id: 5,
    name: 'ايس كوفي نوتيلا',
    price: '65 LE',
    image: IcedNuttella
  }, {
    id: 6,
    name: 'ايس موكا',
    price: '60 LE',
    image: IcedMocha
  }, {
    id: 7,
    name: 'ايس فرابتشينو',
    price: '55 LE',
    image: IcedFrape
  },
  {
    id: 8,
    name: 'ايس كوفي',
    price: '50 LE',
    image: IcedCoffee
  }, {
    id: 9,
    name: 'ايس كورتادو',
    price: '50 LE',
    image: IcedCortado
  },
  {
    id: 10,
    name: 'ماتشا ايس لاتيه',
    price: '65 LE',
    image: IcedlatteMatcha
  },
  {
    id: 11,
    name: 'ماتشا ايس فرابيه',
    price: '80 LE',
    image: MatchaFrappe
  },
]
    },
    // Milkshake
    {
      name: 'ميلك تشيك',
      icon: <FaGlassWhiskey />,
      items: [
        {
          name: 'اوريو',
          price: '40 LE : 50 LE',
          description: '',
          image: MilkShakeOreo,
          id:12
        },
        {
          name: 'لوتس',
          price: '45 LE : 55 LE',
          description: '',
          image: MilkShakeLotus,
          id:13
        },{
          name: 'بلو بيري',
          price: '40 LE : 50 LE',
          description: '',
          image: MilkShakeBlueBerry,
          id:14
        },
        {
          name: 'مانجو',
          price: '40 LE : 50 LE',
          description:'',
          image: MilkShakeMango,
          id:15
        },{
          name: 'فراوله',
          price: '40 LE : 50 LE',
          description: '',
          image: MilkShakeStrawberry,
          id:16
        },
        {
          name: 'بستاشيو',
          price: '70 LE : 85 LE',
          description:'',
          image: MilkShakePistacio,
          id:17
        },{
          name: 'فانيليا',
          price: '40 LE : 50 LE',
          description: '',
          image: MilkShakeVanilla,
          id:18
        },
        {
          name: 'كندر',
          price: '50 LE : 65 LE',
          description:'',
          image: MilkShakeKinder,
          id:19
        },
        {
          name: 'كوفي',
          price: '55 LE : 70 LE',
          description: '',
          image: MilkShakeCoffee,
          id:20
        },{
          name: 'توينكز',
          price: '50 LE',
          image: MilkShakeTwinkies,
          id:21
        },
        {
          name: 'هوهوز',
          price: '50 LE',
          image: MilkShakeHohos,
          id:22
        },
        {
          name: 'ليمون نعناع',
          price: '50 LE',
          image: MilkShakeLemonMint,
          id:23,
        },
        {
          name: 'بطيخ',
          price: '60 LE',
          image: MilkShakeWatermelon,
          id:24
        },{
          name: 'خوخ',
          price: '60 LE',
          image: MilkShakePeach,
          id:25
        },{
          name: 'رفايللو',
          price: '75 LE',
          description: '',
          image: MilkShakeRafayello,
          id:26
        },
          {
          name: 'ماتشا',
          price: '80 LE',
          description: '',
          image: MilkShakeMatcha,
          id:27
        },
        {
          name: 'تارو',
          price: '85 LE',
          description: '',
          image: MilkShakeTaro,
          id:28
        },
        {
          name: 'شوكليت دبي',
          price: '100 LE',
          description: '',
          image: MilkShakeChocolateDobai,
          id:29
        },
      ]
    },
    //smoothie
    {
      name: 'سموزي',
      icon: <FaGlassMartiniAlt />,
     items: [
  {
    id: 30,
    name: 'تفاح',
    price: '55 LE',
    image: AppleSmothie
  },
  {
    id: 31,
    name: 'برتقال',
    price: '60 LE',
    image: OrangeSmothie
  },
  {
    id: 32,
    name: 'فراوله',
    price: '45 LE',
    image: StrawberrySmothie
  },
  {
    id: 33,
    name: 'مانجو',
    price: '50 LE',
    image: MangoSmothie
  },
  {
    id: 34,
    name: 'اناناس',
    price: '85 LE',
    image: PineappleSmothie
  },
  {
    id: 35,
    name: 'بلو بيري',
    price: '45 LE',
    image: BlueBerrySmothie
  },
  {
    id: 36,
    name: 'ليمون نعناع',
    price: '45 LE',
    image: LemonSmothie
  },
  {
    id: 37,
    name: 'خوخ',
    price: '50 LE',
    image: PeachSmothie
  },
  {
    id: 38,
    name: 'جوافه',
    price: '40 LE',
    image: GuavaSmothie
  },
  {
    id: 39,
    name: 'مكس بيري',
    price: '50 LE',
    image: MixBerry
  },
  {
    id: 40,
    name: 'بطيخ',
    price: '45 LE',
    image: WatermelonSmothie
  },
  {
    id: 41,
    name: 'عنب',
    price: '50 LE',
    image: GrapesSmothie
  },
  {
    id: 42,
    name: 'كيوي',
    price: '70 LE',
    image: KiwiSmothie
  },
  {
    id: 43,
    name: 'بلح',
    price: '50 LE',
    image: DatesSmothie
  },
  {
    id: 44,
    name: 'باشون فروت',
    price: '60 LE',
    image: PassionSmothie
  },
  {
    id: 45,
    name: 'راسبيري',
    price: '60 LE',
    image: RassperrrySmothie
  },
  {
    id: 46,
    name: 'دراجون فروت',
    price: '105 LE',
    image: DragonFruitSmothie
  },
  {
    id: 47,
    name: 'ريدبول',
    price: '70 LE',
    image: ''
  },
  {
    id: 48,
    name: 'تين شوكي',
    price: '55 LE',
  },
  {
    id: 49,
    name: 'مانجو باشون',
    price: '50 LE',
    image: MangoPassionSmothie
  },
  {
    id: 50,
    name: 'تين شوكي باشون',
    price: '65 LE',
    image: ''
  },
  {
    id: 51,
    name: 'يوسفي جوزهند',
    price: '65 LE',
    image: YousfiCoconut
  },
  {
    id: 52,
    name: 'اناناس جوزهند',
    price: '75 LE',
    image: DatesSmothie
  },
  {
    id: 53,
    name: 'كيوي ليمون نعناع',
    price: '60 LE',
    image: KiwiLemonMint
  },
  {
    id: 54,
    name: 'كيوي اناناس',
    price: '70 LE',
    image: KiwiPineapple
  },
  {
    id: 55,
    name: 'ايس كريم مانجو',
    price: '60 LE',
    image: IcecreamMango
  },
  {
    id: 56,
    name: 'ايس كريم فراوله',
    price: '60 LE',
    image: IcecreamStrawberry
  },
  {
    id: 57,
    name: 'ايس كريم بطيخ',
    price: '60 LE',
    image: ''
  },
  {
    id: 58,
    name: 'جوافه كيوي نعناع',
    price: '55 LE',
    image: GuavaKiwiMint
  },
  {
    id: 59,
    name: 'مانجو كيوي',
    price: '60 LE',
    image: KiwiMango
  },
  {
    id: 60,
    name: 'بطيخ نعناع',
    price: '50 LE',
    image: WaterMElonMint
  },
  {
    id: 61,
    name: 'مكس علي زوقك',
    price: '70 LE',
    image: ''
  },
]
    },
    //fresh juices
    {
      name: 'عصير طبيعي',
      icon: <RiDrinks2Line />,
     items: [
  {
    id: 62,
    name: 'برتقال',
    price: '45 LE : 55 LE',
    image: Orange
  },
  {
    id: 63,
    name: 'مانجو',
    price: '35 LE : 45 LE',
    image: Mango
  },
  {
    id: 64,
    name: 'جوافة',
    price: '35 LE : 40 LE',
    image: Guava
  },
  {
    id: 65,
    name: 'جوافة بالحليب',
    price: '40 LE : 45 LE',
    image: GuavaMilk
  },
  {
    id: 66,
    name: 'فراولة',
    price: '35 LE : 45 LE',
    image: Strawberry
  },
  {
    id: 67,
    name: 'بطيخ',
    price: '30 LE : 40 LE',
    image: Watermelon
  },
  {
    id: 68,
    name: 'كيوي',
    price: '70 LE : 90 LE',
    image: Kiwi
  },
  {
    id: 69,
    name: 'أناناس',
    price: '65 LE : 75 LE',
    image: Pineapple
  },
  {
    id: 70,
    name: 'ليمونادة',
    price: '25 LE : 30 LE',
    image: lemonada
  },
  {
    id: 71,
    name: 'ليمون ونعناع',
    price: '30 LE : 35 LE',
    image: Lemonmint
  },
  {
    id: 72,
    name: 'بلح بالحليب',
    price: '45 LE : 50 LE',
    image: DatesMilk
  },
  {
    id: 73,
    name: 'جوز هند طبيعي',
    price: '50 LE : 65 LE',
    image: Coconut
  },
  {
    id: 74,
    name: 'موز بالحليب',
    price: '35 LE : 45 LE',
    image: BananaMilk
  },
  {
    id: 75,
    name: 'كنتالوب بالحليب',
    price: '35 LE : 45 LE',
    image: CantalopMilk
  },
  {
    id: 76,
    name: 'عنب',
    price: '50 LE',
    image: Grapes
  },
  {
    id: 77,
    name: 'برقوق',
    price: '60 LE',
    image: ''
  },
  {
    id: 78,
    name: 'خوخ',
    price: '45 LE : 55 LE',
    image: Peach
  },
  {
    id: 79,
    name: 'رمان',
    price: '60 LE',
    image: ''
  },
  {
    id: 80,
    name: 'دراجون فروت',
    price: '100 LE',
    image: DragonFruit
  },
]
    },
    //babo
     {
      name: 'بوبا',
      icon: <FaWhiskeyGlass/>,
      items: [
        {
          id: 81,
          name: 'ميلك شيك ماتشا',
          price: '100 LE',
          image: BobaMilkShakeMatcha
        },
        {
          id: 82,
          name: 'ميلك شيك تارو',
          price: '100 LE',
          image: BobaMilkShakeTaro
        },
        {
          id: 83,
          name: 'ميلك شيك شوكولاتة',
          price: '70 LE',
          image: BobaMilkShakeChocolate
        },{
          id: 84,
          name: 'ميلك شيك أوريو',
          price: '70 LE',
          image: BobaMilkShakeChocolate
        },
        {
          id: 85,
          name: 'ميلك شيك فراولة',
          price: '75 LE',
          image: BobaMilkShakeStrawberry
        }, {
          id: 86,
          name: 'ميلك شيك لوتس',
          price: '75 LE',
          image: BobaMilkShakelotus
        },{
          id: 87,
          name: 'ميلك شيك فانيليا',
          price: '75 LE',
          image: BobaMikShakeVanellia
        },{
          id: 88,
          name: 'ميلك شيك توت أزرق',
          price: '75 LE',
          image: BobaMilkShakeBlueBerry
        },{
          id: 89,
          name: 'ميلك شيك كراميل',
          price: '70 LE',
          image: BobaMilkShakeCaramel
        },{
          id: 90,
          name: 'صودا باشن فروت',
          price: '75 LE',
          image: BobaSodaPassion
        },{
          id: 91,
          name: 'صودا موهيتو',
          price: '75 LE',
          image: ''
        },{
          id: 92,
          name: 'صودا بيري',
          price: '75 LE',
          image: ''
        },{
          id: 93,
          name: 'صودا كريز',
          price: '75 LE',
          image: ''
        },{
          id: 94,
          name: 'سموزي فراولة',
          price: '70 LE',
          image: BobaStrawberry
        },{
          id: 95,
          name: 'سموزي كيوي',
          price: '90 LE',
          image: BobaKiwi
        },{
          id: 96,
          name: 'سموزي خوخ',
          price: '75 LE',
          image: BobaPeach
        },{
          id: 97,
          name: 'سموزي مانجو',
          price: '75 LE',
          image: BobaMango
        },
        {
          id: 98,
          name: 'سموزي ليمون ونعناع',
          price: '65 LE',
          image: ''
        },
        {
          id: 99,
          name: 'سموزي توت أزرق',
          price: '60 LE',
          image: ''
        },
        {
          id: 100,
          name: 'سموزي بطيخ',
          price: '65 LE',
          image: BobaWatermelon
        },
        {
          id: 101,
          name: 'سموزي مكس بيري',
          price: '60 LE',
          image: ''
        },
        {
          id: 102,
          name: 'ايس كوفي',
          price: '70 LE',
          image: BobaIcedCoffe
        },{
          id: 103,
          name: 'موكا',
          price: '75 LE',
          image: BobaMocha
        },{
          id: 104,
          name: 'فرابتشينو',
          price: '75 LE',
          image: BobaFrappe
        },
        {
          id: 105,
          name: 'ايس كراميل ميكاتو',
          price: '65 LE',
          image: ''
        },{
          id: 106,
          name: 'سبانش لاتيه',
          price: '75 LE',
          image: BobaSpanishLatte
        },
      ]
    },
    // Hb Boxs
      {
      name: 'بوكسات',
      icon: <LuBox/>,
      items: [
        {
          name: 'Kids box',
          price: '65 LE',
          description: '1 waffel , 1 donnets , 1 freska , 5 mini bancake',
        },
        {
          name: 'بوكس الدلع',
          price: '110 LE',
          description: '2 waffel , 2 donnets , 2 freska , 6 mini bancake',
        }, {
          name: 'بوكس السعاده',
          price: '150 LE',
          description: '3 waffel , 3 donnets , 3 freska , 12 mini bancake',
          image: ""
        },{
          name: 'بوكس الصحاب',
          price: '200 LE',
          description: '4 waffel , 4 donnets , 4 freska , 25 mini bancake',
        },
      ]
    },
    //waffel
     {
      name: 'وافل',
      icon: <FaStroopwafel/>,
      items: [
  {
    id: 107,
    name: 'كراميل',
    price: '50 LE',
    image: ""
  },
  {
    id: 108,
    name: 'شوكولاتة',
    price: '50 LE',
    description: '',
    image: ""
  },
  {
    id: 109,
    name: 'نوتيلا',
    price: '60 LE',
    image: ""
  }, {
    id: 110,
    name: 'شوكولاتة بيضاء',
    price: '60 LE',
    image: ""
  },
  {
    id: 111,
    name: 'لوتس',
    price: '65 LE',
    image: ""
  }, {
    id: 112,
    name: 'أوريو',
    price: '65 LE',
    image: ""
  },
  {
    id: 113,
    name: 'كيندر',
    price: '65 LE',
    image: ""
  }, {
    id: 114,
    name: 'فستق',
    price: '80 LE',
    description: '',
    image: ""
  },
  {
    id: 115,
    name: 'رافاييلو',
    price: '80 LE',
    description: '',
    image: ""
  },
  {
    id: 116,
    name: 'وافل ستيك',
    price: '15 LE',
    description: 'كراميل',
    image: ""
  }, {
    id: 117,
    name: 'وافل ستيك',
    price: '20 LE',
    description: '(لوتس، شوكولاتة بيضاء، شوكولاتة داكنة)',
    image: ""
  }, {
    id: 118,
    name: 'وافل ستيك',
    price: '25 LE',
    description: '(نوتيلا، كيندر)',
    image: ""
  }, {
    id: 119,
    name: 'وافل ستيك',
    price: '30 LE',
    description: '(فستق)',
    image: ""
  },
]
    },
    //fresh & soda Cocktails
     {
      name: 'كوكتيل',
      icon: <LuCupSoda/>,
      items: [
  {
    id: 120,
    name: 'فلوريدا',
    price: '55 LE',
    description: 'مانجو + فراولة + جوافة',
    image: ""
  },
  {
    id: 121,
    name: 'كي يانجو',
    price: '60 LE',
    description: 'مانجو + كيوي',
    image: ""
  },
  {
    id: 122,
    name: 'آيسلاند',
    price: '60 LE',
    description: 'مانجو + آيس كريم + جوزهند + موز',
    image: ""
  },
  {
    id: 123,
    name: 'صن شاين',
    price: '60 LE',
    description: 'رمان + برتقال + صودا',
    image: ""
  }, 
  {
    id: 124,
    name: 'فو مانجو',
    price: '65 LE',
    description: 'مانجو + أفوكادو + موز',
    image: ""
  },
  {
    id: 125,
    name: 'كوكتيل إتش بي',
    price: '100 LE',
    description: 'مفاجأة',
    image: ""
  },
  {
    id: 126,
    name: 'بلو هاواي صودا',
    price: '50 LE',
    description: 'بلو كرواسو + صودا + أناناس',
    image:""
  },
  {
    id: 127,
    name: 'موهيتو صودا',
    price: '55 LE',
    description: 'ليمون + نعناع + سكر بني + صودا',
    image: ""
  },
  {
    id: 128,
    name: 'بينا كولادا صودا',
    price: '65 LE',
    description: 'أناناس + لبن + جوزهند',
    image: ""
  },
  {
    id: 129,
    name: 'كيوي بيستو صودا',
    price: '70 LE',
    description: 'كيوي + عسل + ريحان + صودا',
    image: ""
  },
]
    },
    //mini pancake & dounts
    {
      name: 'ميني دونت & بان كيك',
      icon: <LuDonut/>,
      items: [
        {
          name: '2 ميني دونت لوتس',
          price: '25 LE',
          description: '',
          image: "",
          id:170,
        },
        {
          name: '2 ميني دونت شوكليت ',
          price: '20 LE',
          description: '',
          image: "",
          id:171
        },{
          name: '2 ميني دونت نيوتيلا',
          price: '25 LE',
          image: "",
          id:172
        },{
          name: '2 ميني دونت بستاشيو',
          price: '40 LE',
          image: "",
          id:173
        },{
          name: '2 ميني دونت وايت شوكليت',
          price: '25 LE',
          description: '',
          image: "",
          id:174
        },{
          name: '2 ميني دونت كندر',
          price: '35 LE',
          description: '',
          image: "",
          id:175
        },
        {
          name: '2 ميني دونت رفايللو',
          price: '40 LE',
          description: '',
          image: "",
          id:176
        },
        {
          name: 'بوكس 6 قطع ',
          price: '70 LE',
          description: 'تشكيله من غير بستاشيو و رفايللو',
          image: "",
          id:177
        },{
          name: 'بوكس 6 قطع اسبشيال',
          price: '90 LE',
          description: 'تشكيله علي زوقك',
          image: "",
          id:178
        },
        {
          name: 'ميني بان كيك وايت شوكليت',
          price: '30 LE : 60 LE',
          description: '12 pieces (30 LE) , 25 pieces (60 LE)',
          image: "",
          id:179,
        },{
          name: 'ميني بان كيك نوتيلا',
          price: '30 LE : 60 LE',
          description: '12 pieces (30 LE) , 25 pieces (60 LE)',
          image: "",
          id:180
        },
        {
          name: 'ميني بان كيك شوكليت',
          price: '25 LE : 40 LE',
          description: '12 pieces (25 LE) , 25 pieces (40 LE)',
          image: "",
          id:181
        },{
          name: 'ميني بان كيك لوتس',
          price: '30 LE : 50 LE',
          description: '12 pieces (30 LE) , 25 pieces (50 LE)',
          image: "",
          id:182
        },
        {
          name: 'ميني بان كيك بستاشيو',
          price: '40 LE : 70 LE',
          description: '12 pieces (40 LE) , 25 pieces (70 LE)',
          image: "",
          id:183
        },
        {
          name: 'ميني بان كيك رفايللو',
          price: '40 LE : 70 LE',
          description: '12 pieces (40 LE) , 25 pieces (70 LE)',
          image: "",
          id:184
        },
        {
          name: 'ميني بان كيك اوريو',
          price: '30 LE : 45 LE',
          description: '12 pieces (30 LE) , 25 pieces (45 LE)',
          image: "",
          id:185
        },
        {
          name: 'ميني بان كيك عسل',
          price: '30 LE : 60 LE',
          description: '12 pieces (30 LE) , 25 pieces (60 LE)',
          image: "",
          id:186
        },{
          name: 'ميني بان كيك مكس',
          price: '60 LE',
          description: '25 pieces (60 LE)',
          image: "",
          id:187
        },
        {
          name: 'ميني بان كيك مكس اسبيشيال',
          price: '80 LE',
          description: '25 pieces (80 LE)',
          image: "",
          id:188
        },
      ]
    },
    //takco & cream puff
    {
      name: 'تاكو & وكريم باف',
      icon: <GiTacos/>,
      items: [
        {
          id: 120,
          name: 'تاكو آيس كريم نوتيلا',
          price: '55 LE',
          description: '',
          image: ""
        },
        {
          id: 121,
          name: 'تاكو آيس كريم كراميل',
          price: '55 LE',
          description: '',
          image: ""
        },{
          id: 122,
          name: 'تاكو آيس كريم شوكولاتة',
          price: '55 LE',
          description: '',
          image: ""
        },{
          id: 123,
          name: 'تاكو آيس كريم أوريو',
          price: '55 LE',
          description: '',
          image: ""
        },
        {
          id: 124,
          name: 'تاكو آيس كريم لوتس',
          price: '65 LE',
          description: '',
          image: ""
        },
        {
          id: 125,
          name: 'تاكو آيس كريم فستق',
          price: '75 LE',
          description: '',
          image: ""
        },{
          id: 126,
          name: 'كريم باف لوتس',
          price: '60 LE',
          description: '',
          image: ""
        },
        {
          id: 127,
          name: 'كريم باف نوتيلا',
          price: '60 LE',
          description: '',
          image: ""
        },
        {
          id: 128,
          name: 'كريم باف فستق',
          price: '75 LE',
          description: '',
          image: ""
        },
      ]
    },
    //avocado
    {
      name: 'أفوكادو',
      icon: <GiAvocado/>,
      items: [
        {
          id: 129,
          name: 'لبن وعسل',
          price: '100 LE',
          description: '',
          image: ""
        },
        {
          id: 130,
          name: 'لبن وعسل ومكسرات',
          price: '110 LE',
          description: '',
          image: ""
        },{
          id: 131,
          name: 'كيوي',
          price: '120 LE',
          description: '',
          image: ""
        },{
          id: 132,
          name: 'مانجو',
          price: '95 LE',
          description: '',
          image: ""
        },
        {
          id: 133,
          name: 'فراولة',
          price: '95 LE',
          description: '',
          image: ""
        },
        {
          id: 134,
          name: 'أفوكادو وجرجير وعسل ولبن ومكسرات',
          price: '115 LE',
          description: '',
          image: ""
        }
      ]
    },
    //madness & fresca
    {
      name: 'مادنس & فريسكا',
      icon: <GiFireSpellCast/>,
      items: [
        {
          id: 135,
          name: 'مادنس أوريو',
          price: '55 LE',
          image: ""
        },
        {
          id: 136,
          name: 'مادنس لوتس',
          price: '55 LE',
          image: ""
        },{
          id: 137,
          name: 'مادنس نوتيلا',
          price: '60 LE',
          image: ""
        },{
          id: 138,
          name: 'مادنس فستق',
          price: '75 LE',
          image: ""
        },
        {
          id: 139,
          name: 'فريسكا أوريو',
          price: '30 LE',
          image: ""
        },
        {
          id: 140,
          name: 'فريسكا دارك شوكليت',
          price: '25 LE',
          image: ""
        },
        {
          id: 141,
          name: 'فريسكا وايت شوكليت',
          price: '30 LE',
          image: ""
        },
        {
          id: 142,
          name: 'فريسكا توينكز',
          price: '30 LE',
          image: ""
        },
        {
          id: 143,
          name: 'فريسكا هوهوز',
          price: '30 LE',
          image: ""
        },
        {
          id: 144,
          name: 'فريسكا لوتس',
          price: '40 LE',
          image: ""
        },{
          id: 145,
          name: 'فريسكا نوتيلا',
          price: '40 LE',
          image: ""
        },
        {
          id: 146,
          name: 'فريسكا كيندر',
          price: '40 LE',
          image: ""
        }, 
        {
          id: 147,
          name: 'فريسكا رافاييلو',
          price: '40 LE',
          image: ""
        },
      ]
    },
    //extra
    {
      name: 'إضافات',
      icon: <GiExpander/>,
      items: [
        {
          id: 148,
          name: 'كريمة',
          price: '15 LE',
          description: '',
          image: ""
        },
        {
          id: 149,
          name: 'عسل',
          price: '15 LE',
          description: '',
          image: ""
        },
        {
          id: 150,
          name: 'شيا',
          price: '15 LE',
          description: '',
          image: ""
        },{
          id: 151,
          name: 'مكسرات',
          price: '15 LE',
          description: '',
          image: ""
        },
        {
          id: 152,
          name: 'بوبا على أي مشروب',
          price: '30 LE',
          description: '',
          image: ""
        },{
          id: 153,
          name: 'فستق',
          price: '40 LE',
          description: '',
          image: ""
        },
      ]
    },
  ];
  export default menuCategories